import { Outlet } from "react-router-dom";
import useLoggedInRoute from "./hooks/useLoggedInRoute";

const ProtectedRoute = () => {
    const {} = useLoggedInRoute();
    return <Outlet/>
}

export default ProtectedRoute;